import { Value } from "../value.js";
/**
 * @internal
 */
export class Function extends Value {
    _kind;
    constructor(kind, hasCalculation) {
        super("transform", hasCalculation);
        this._kind = kind;
    }
    get kind() {
        return this._kind;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            kind: this._kind,
        };
    }
}
//# sourceMappingURL=function.js.map